import { isIgnorableClientError } from '~/utils/clientErrorFilter'

let resolveEndpoint: (() => string) | null = null

export function initClientErrorReporter(resolve: () => string) {
  resolveEndpoint = resolve
}

export function reportClientError(
  error: unknown,
  extra?: { source?: string },
) {
  if (!import.meta.client || !resolveEndpoint) return
  if (isIgnorableClientError(error)) return

  const message = error instanceof Error
    ? error.message
    : typeof error === 'string'
      ? error
      : ''
  if (!message.trim()) return

  const path = window.location.pathname
  const key = `${message}:${path}`
  const now = Date.now()
  const store = window as Window & { __platformErrorLog?: { key: string, at: number } }
  if (store.__platformErrorLog && store.__platformErrorLog.key === key && now - store.__platformErrorLog.at < 8000) {
    return
  }
  store.__platformErrorLog = { key, at: now }

  const endpoint = resolveEndpoint()
  if (!endpoint) return

  const stack = error instanceof Error ? error.stack : undefined
  void fetch(endpoint, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      message: message.slice(0, 2000),
      stack: stack?.slice(0, 8000),
      url: window.location.href.slice(0, 500),
      source: extra?.source || 'window',
    }),
  }).catch(() => {})
}
